/**
 * @generated SignedSource<<83a2d8b891919354b4a371e0d3b595de>>
 * @relayHash 3354cc4202d42c6c5ace34b7d2c7f774
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c55cb735663043e184d5adef47ee8599cdf2febd8c3e6ce1d01460696ef3aa4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0c55cb735663043e184d5adef47ee8599cdf2febd8c3e6ce1d01460696ef3aa4",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
